import { type EditApplication, type EditConfig, type EditMaxLocations, type EditStation, type EditUser, type Login, type ResetEmail, type ResetPassword, type StationSort, type EditAlert, type CreateApiKey } from '../../shared/types';
import { fetcher } from './index';

export const getUser = async () => await fetcher({ method: 'get', url: 'user' });

export const getAdmin = async () => await fetcher({ method: 'get', url: 'admin' });

export const postUserLogin = async (data: Login) => await fetcher({ method: 'post', url: 'user/login', data });

export const postUserResetEmail = async (data: ResetEmail) => await fetcher({ method: 'post', url: 'user/reset-email', data });

export const postUserResetPassword = async (data: ResetPassword) => await fetcher({ method: 'post', url: 'user/reset-password', data });

export const getAdminUsers = async () => await fetcher({ method: 'get', url: 'admin/users' });

export const putAdminUser = async (id: string, data: EditUser) => await fetcher({ method: 'put', url: `admin/users/${id}`, data });

export const postAdminUser = async (data: EditUser) => await fetcher({ method: 'post', url: 'admin/users', data });

export const postCreateApiKey = async (data: CreateApiKey) => await fetcher({ method: 'post', url: 'admin/users/apikey', data });

export const deleteAdminUser = async (id: string) => await fetcher({ method: 'delete', url: `admin/users/${id}` });

export const getAdminStations = async () => await fetcher({ method: 'get', url: 'admin/stations' });

export const putAdminStation = async (id: string, data: EditStation) => await fetcher({ method: 'put', url: `admin/stations/${id}`, data });

export const postAdminStation = async (data: EditStation) => await fetcher({ method: 'post', url: 'admin/stations', data });

export const deleteAdminStation = async (id: string) => await fetcher({ method: 'delete', url: `admin/stations/${id}` });

export const postAdminStationsSort = async (data: StationSort) => await fetcher({ method: 'post', url: 'admin/stations/sort', data });

export const getAdminApplications = async () => await fetcher({ method: 'get', url: 'admin/applications' });

export const putAdminApplication = async (id: string, data: EditApplication) => await fetcher({ method: 'put', url: `admin/applications/${id}`, data });

export const postAdminApplication = async (data: EditApplication) => await fetcher({ method: 'post', url: 'admin/applications', data });

export const deleteAdminApplication = async (id: string) => await fetcher({ method: 'delete', url: `admin/applications/${id}` });

export const getAdminMaxLocations = async () => await fetcher({ method: 'get', url: 'admin/max-locations' });

export const putAdminMaxLocation = async (id: string, data: EditMaxLocations) => await fetcher({ method: 'put', url: `admin/max-locations/${id}`, data });

export const postAdminMaxLocation = async (data: EditMaxLocations) => await fetcher({ method: 'post', url: 'admin/max-locations', data });

export const deleteAdminMaxLocation = async (id: string) => await fetcher({ method: 'delete', url: `admin/max-locations/${id}` });

export const getAdminConfigs = async () => await fetcher({ method: 'get', url: 'admin/configs' });

export const putAdminConfig = async (id: string, data: EditConfig) => await fetcher({ method: 'put', url: `admin/configs/${id}`, data });

export const postAdminConfig = async (data: EditConfig) => await fetcher({ method: 'post', url: 'admin/configs', data });

export const deleteAdminConfig = async (id: string) => await fetcher({ method: 'delete', url: `admin/configs/${id}` });

export const getAdminMaxSummaries = async () => await fetcher({ method: 'get', url: 'admin/max-summaries' });

export const postRunService = async (service: string) => await fetcher({ method: 'post', url: `admin/services/run/${service}` });

export const getAdvisory = async (id: string) => await fetcher({ method: 'get', url: `advisory/${id}` });

export const getObservations = async () => fetcher({ method: 'get', url: 'observations' });

export const getForecastDays = async (id: string) => fetcher({ method: 'get', url: `forecast/days/${id}` });

export const getForecastHours = async (id: string, utcDate: string) => fetcher({ method: 'get', url: `forecast/hours/${id}?utcDate=${utcDate}` });

export const getAlerts = async () => fetcher({ method: 'get', url: 'alerts' });

export const postAlert = async (data: EditAlert) => await fetcher({ method: 'post', url: 'alerts', data });

export const putAlert = async (id: string, data: EditAlert) => await fetcher({ method: 'put', url: `alerts/${id}`, data });

export const deleteAlert = async (id: string) => await fetcher({ method: 'delete', url: `alerts/${id}` });

export const postAlertSnooze = async (id: string, data: EditAlert) => await fetcher({ method: 'post', url: `alerts/${id}/snooze`, data });

export const getStations = async () => fetcher({ method: 'get', url: 'stations' });
